
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CertproEvaluationComponent } from '../evaluation/evaluation.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-evaluate-certpro',
  templateUrl: './evaluate.component.html',
  styleUrls: ["./evaluate.component.scss"],
  imports: [CertproEvaluationComponent, DragDropModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class CertproEvaluateComponent implements OnInit {
  protected period: string
  protected entity: string
  protected review = false
  private route = inject(ActivatedRoute)
  private router = inject(Router)

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams
    if (params['period']) this.period = params['period']
    if (params['entity']) this.entity = params['entity']
    if (params['review']) this.review = true
  }

  back() {
    this.router.navigate(['/historial'])
  }

} 
